import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const CancelPage = () => {
  const navigate = useNavigate();

  // Navegación hacia el inicio cuando se carga la página
  useLayoutEffect(() => {
    navigate('/cancel', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4 text-red-800">Payment Cancelled!</h2>
        
        {import.meta.env.VITE_STRIPE_CANCEL_SESSION_ID ? (
          <>
            <p className="mb-6">
              The payment process could not be completed.
              Session ID: {import.meta.env.VITE_STRIPE_CANCEL_SESSION_ID}
            </p>
            <button
              onClick={() => navigate('/payments')}
              className="px-6 py-3 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors"
            >
              Try Again
            </button>
          </>
        ) : (
          <>
            <p className="mb-4">Could not determine the exact status of your payment.</p>
            <div className="flex flex-col gap-2 mb-6">
              <button
                onClick={() => navigate('/payments')}
                className="px-6 py-3 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition-colors"
              >
                Purchase Bundle
              </button>
              <button
                onClick={() => navigate('/payments/single')}
                className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
              >
                Pay Single Consultation
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CancelPage;